






















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user/user.store';
import { User } from '@/models/user/user.model';
import dateFormat from '@/plugins/filters/dateFormat.filter';
import { ApiPermissions } from '@/core/security/Permissions';

import EditWebsitePassword from './EditWebsitePassword.vue';
import { ModalConstants } from '@/core/constants';
import { AdminApi } from '@/services/api/api.admin';
import { UpdateUserRequest } from '@/types/apiServerContract';

@Component({
    components: { EditWebsitePassword }
})
export default class EditUserProfile extends Vue {
	@Prop() user!: User;

	permissions: string[] = [ApiPermissions.User.EditWebsiteProfile];
	profile: User = Object.assign({}, this.user);
	loading: boolean = false;

	get CanUpdatePassword() {
	    return UserModule.user?.HasPermission([ApiPermissions.User.EditWebsitePassword]);
	}

	ShowPasswordOverlay() {
	    this.$bvModal.show(ModalConstants.ChangeWebsitePassword);
	}

	async UpdateUser() {
	    const check = await this.$bvModal.msgBoxConfirm('Are you sure you wish to save these changes?', {
	        centered: true,
	        okTitle: 'Yes'
	    });
	    if (!check) return;

	    this.loading = true;

	    try {
	        const request: UpdateUserRequest = {
	            userId: this.user.id,
	            username: this.profile.userName,
	            location: this.profile.location,
	            email: this.profile.email
	        };
	        await AdminApi.UpdateWebsiteProfile(request);
	    } finally {
	        this.loading = false;
	    }

	    this.$bvToast.toast(`${this.user.userName}'s profile has been updated successfully`, {
	        variant: 'success',
	        title: 'Success'
	    });
	}

	GetDate(date: Date) {
	    if (!date) return 'Never';
	    return dateFormat(date);
	}

	Reset() {
	    this.profile = Object.assign({}, this.user);
	}
}
